var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          staticClass: "navbar position-absolute",
          attrs: { toggleable: "lg" }
        },
        [
          _c("b-navbar-brand", { attrs: { href: "/" } }, [
            _c("img", {
              staticClass: "navbar-brand-img",
              attrs: { src: _vm.getLogo }
            })
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c("b-navbar-nav", { staticClass: "ml-auto" }, [
                _c(
                  "span",
                  { staticStyle: { display: "contents" } },
                  [
                    _c(
                      "b-nav-item",
                      [
                        _c(
                          "base-button",
                          {
                            attrs: { blue: "" },
                            on: {
                              click: function($event) {
                                return _vm.$router.push("/inicio-sesion")
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("openlegal.menu.sign-in")))
                            ]),
                            _vm._v(" "),
                            _c("base-icon", {
                              staticClass: "ml-2",
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: _vm.$uiHelpers.isMobile
                                  ? _vm.ORANGE_COLOUR
                                  : "white"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("openlegal-main-block"),
      _vm._v(" "),
      _c("openlegal-cards-slider"),
      _vm._v(" "),
      _c("openlegal-for-companies", { attrs: { id: "companies-block" } }),
      _vm._v(" "),
      _c("openlegal-for-individuals", { attrs: { id: "singles-block" } }),
      _vm._v(" "),
      _c("openlegal-specialties"),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section mx-auto pt-5 pt-sm-0",
          staticStyle: { "min-height": "50vh !important" },
          attrs: { id: "big-companies" }
        },
        [
          _c(
            "div",
            { staticClass: "my-auto text-center" },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("h5", { staticClass: "desktop-fix" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("openlegal.companies")) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "logos-ctn", attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "logos-row" },
                    [
                      _c("b-col", { attrs: { "offset-md": "1", md: "2" } }, [
                        _c("img", {
                          staticStyle: { opacity: ".5", width: "40%" },
                          attrs: {
                            src: "/static-appopensalud/img/logos/aon.svg",
                            alt: "AON"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          attrs: {
                            src: "/static-appopensalud/img/logos/barcelo.svg",
                            alt: "Barcelo"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          staticStyle: { opacity: ".5" },
                          attrs: {
                            src: "/static-appopensalud/img/logos/IKEA.svg",
                            alt: "IKEA"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          staticStyle: { opacity: ".5" },
                          attrs: {
                            src: "/static-appopensalud/img/logos/msm.svg",
                            alt: "Mahou San Miguel"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          staticStyle: { opacity: ".5", width: "40%" },
                          attrs: {
                            src: "/static-appopensalud/img/logos/mp.png",
                            alt: "MP Ascensores"
                          }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "logos-row mt-lg-5" },
                    [
                      _c("b-col", { attrs: { "offset-md": "1", md: "2" } }, [
                        _c("img", {
                          attrs: {
                            src: "/static-appopensalud/img/logos/siemens.svg",
                            alt: "Siemens"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          staticStyle: { width: "65%" },
                          attrs: {
                            src: "/static-appopensalud/img/logos/santander.svg",
                            alt: "Santander"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          staticStyle: { opacity: ".5" },
                          attrs: {
                            src:
                              "/static-appopensalud/img/logos/novo-nordisk.svg",
                            alt: "Novo Nordisk"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          staticStyle: { opacity: ".5" },
                          attrs: {
                            src: "/static-appopensalud/img/logos/IVECO.svg",
                            alt: "Iveco"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "2" } }, [
                        _c("img", {
                          staticStyle: { opacity: ".5" },
                          attrs: {
                            src: "/static-appopensalud/img/logos/loreal.svg",
                            alt: "L'Oréal"
                          }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("companies-contact-form", {
        attrs: {
          serviceType: _vm.$t("legal-services"),
          forIndividuals: "",
          platform: "Openlegal",
          productName: "Openlegal",
          showReason: "",
          hideEmployeesNumber: ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e88c4c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e88c4c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/openlegal/Vertical.vue
// module id = 3700
// module chunks = 12